import React, { useState } from "react";
import Button from "components/Button";
import Input from "components/Input";
import Text from "components/Text";
import CheckBox from "components/CheckBox";
import styles from "./index.module.css";

import { ReactComponent as Icon } from "assets/icons/Icon.svg";
import { ReactComponent as EyeIcon } from "assets/icons/passwordView.svg";

export default function Components() {
    const [value, setValue] = useState("");
    const [show, setShow] = useState(false);
    const [checkboxValue1, setCheckboxValue1] = useState(false);
    const [checkboxValue2, setCheckboxValue2] = useState(false);

    const handleShowPasswordClick = () => {
        setShow((current) => !current);
    };

    return (
        <div className={styles.container}>
            <div className={styles.buttons}>
                <h2>Buttons</h2>

                <details>
                    <summary className={styles.summary}>
                        <Button label="A Primary button" variant="primary" />
                    </summary>
                    <pre className={styles.pre}>
                        {"<Button label=\"A Primary button\" />"}
                    </pre>
                </details>

                <details>
                    <summary className={styles.summary}>
                        <Button label="A Primary button with Icon" icon={<Icon />} />
                    </summary>
                    <pre className={styles.pre}>
                        {`
            import { ReactComponent as Icon } from "../../assets/images/Icon.svg";
            
            <Button label="A Primary button with Icon" icon={<Icon />} />
            `}
                    </pre>
                </details>

                <details>
                    <summary className={styles.summary}>
                        <Button label="A secondary button" variant="secondary" />
                    </summary>
                    <pre className={styles.pre}>
                        {"<Button label=\"A secondary button\" variant=\"secondary\" />"}
                    </pre>
                </details>

                <details>
                    <summary className={styles.summary}>
                        <Button
                            label="A tertiary large button"
                            variant="tertiary"
                            size="large"
                        />
                    </summary>
                    <pre className={styles.pre}>
                        {"<Button label=\"A tertiary large button\" variant=\"tertiary\" size=\"large\" />"}
                    </pre>
                </details>

                <details>
                    <summary className={styles.summary}>
                        <Button label="A ghost button" variant="ghost" />
                    </summary>
                    <pre className={styles.pre}>
                        {"<Button label=\"A ghost button\" variant=\"ghost\" />"}
                    </pre>
                </details>

                <details>
                    <summary className={styles.summary}>
                        <Button label="Disabled Button" disabled />
                    </summary>
                    <pre className={styles.pre}>
                        {"<Button label=\"Disabled Button\" disabled />"}
                    </pre>
                </details>
            </div>

            <div className={styles.inputs}>
                <h2 style={{ marginBottom: 20 }}>Input</h2>

                <details>
                    <summary className={styles.summary}>
                        <Input
                            label="Test Input"
                            placeholder="enter value"
                            value={value}
                            onChange={setValue}
                        />
                    </summary>
                    <pre className={styles.pre}>
                        {`
            const [value, setValue] = useState("");

            <Input
              label="Test Input"
              placeholder="enter value"
              value={value}
              onChange={setValue}
            />
            `}
                    </pre>
                </details>

                <details>
                    <summary className={styles.summary}>
                        <Input
                            label="Test password with view Icon"
                            placeholder="enter value"
                            endIcon={<EyeIcon onClick={handleShowPasswordClick} />}
                            value={value}
                            onChange={setValue}
                            type={show ? "text" : "password"}
                        />
                    </summary>
                    <pre className={styles.pre}>
                        {`
            const [value, setValue] = useState("");

            <Input
              label="Test password with view Icon"
              placeholder="enter value"
              endIcon={<EyeIcon />}
              value={value}
              onChange={setValue}
            />
            `}
                    </pre>
                </details>
            </div>

            <div className={styles.texts}>
                <Text type={"h1"}>Texts</Text>

                <details>
                    <summary className={styles.summary}>
                        <Text type={"p1"}>p1 text</Text>
                    </summary>
                    <pre className={styles.pre}>
                        {"<Text type={'p1'}>p1 text</Text>"}
                    </pre>
                </details>

                <details>
                    <summary className={styles.summary}>
                        <Text type={"p2"}>p2 text</Text>
                    </summary>
                    <pre className={styles.pre}>
                        {"<Text type={'p2'}>p2 text</Text>"}
                    </pre>
                </details>

                <details>
                    <summary className={styles.summary}>
                        <Text type={"h1"} color="primary">
                            h1 text primary color
                        </Text>
                    </summary>
                    <pre className={styles.pre}>
                        {"<Text type={\"h1\"} color=\"primary\">h1 text primary color </Text>"}
                    </pre>
                </details>

                <details>
                    <summary className={styles.summary}>
                        <Text type={"h1"} color="secondary">
                            h1 text secondary color
                        </Text>
                    </summary>
                    <pre className={styles.pre}>
                        {"<Text type={\"h1\"} color=\"secondary\">h1 text secondary color</Text>"}
                    </pre>
                </details>

                <details>
                    <summary className={styles.summary}>
                        <Text type={"h2"} color="orange">
                            h2 text orange color
                        </Text>
                    </summary>
                    <pre className={styles.pre}>
                        {"<Text type={\"h2\"} color=\"orange\">h2 text orange color</Text>"}
                    </pre>
                </details>

                <details>
                    <summary className={styles.summary}>
                        <Text type={"h3"}>h3 text</Text>
                    </summary>
                    <pre className={styles.pre}>
                        {"<Text type={'h3'}>h3 text</Text>"}
                    </pre>
                </details>

                <details>
                    <summary className={styles.summary}>
                        <Text type={"h4"}>h4 text</Text>
                    </summary>
                    <pre className={styles.pre}>
                        {"<Text type={'h4'}>h4 text</Text>"}
                    </pre>
                </details>

                <details>
                    <summary className={styles.summary}>
                        <Text type={"h5"}>h5 text</Text>
                    </summary>
                    <pre className={styles.pre}>
                        {"<Text type={'h5'}>h5 text</Text>"}
                    </pre>
                </details>

                <details>
                    <summary className={styles.summary}>
                        <Text type={"xl"}>xl number - 999</Text>
                    </summary>
                    <pre className={styles.pre}>
                        {"<Text type={'xl'}>xl number - 999</Text>"}
                    </pre>
                </details>

                <details>
                    <summary className={styles.summary}>
                        <Text type={"l"}>l number - 999</Text>
                    </summary>
                    <pre className={styles.pre}>
                        {"<Text type={'l'}>l number - 999</Text>"}
                    </pre>
                </details>
            </div>



            <div className={styles.checkbox}>
                <h2 style={{ marginBottom: 20 }}>Checkbox</h2>
                <details>
                    <summary className={styles.summary}>
                        <CheckBox
                            label="checkbox"
                            checked={checkboxValue1}
                            onClick={(e) => setCheckboxValue1(e.target.checked)}
                        />
                    </summary>
                    <pre className={styles.pre}>
                        {"<CheckBox label='Remember me'checked={checkboxValue1} onClick={(e) => setCheckboxValue1(e.target.checked)}/>"}
                    </pre>
                </details>

                <details>
                    <summary className={styles.summary}>
                        <CheckBox
                            label="checkbox"
                            checked={checkboxValue2}
                            onClick={(e) => setCheckboxValue2(e.target.checked)}
                            uncheckStyleVariant="greyedOut"
                        />
                    </summary>
                    <pre className={styles.pre}>
                        {"<CheckBox label='Remember me' checked={checkboxValue2} onClick={(e) => setCheckboxValue2(e.target.checked)} uncheckStyleVariant='greyedOut'/>"}
                    </pre>
                </details>
            </div>
        </div>
    );
}
